// extracted by mini-css-extract-plugin
module.exports = {"block":"LoadPage_block_1Alh2","logoBlock":"LoadPage_logoBlock_JhQvN","logo":"LoadPage_logo_eKP4x","wrapper":"LoadPage_wrapper_3W91x"};